export default __webpack_public_path__ + "static/media/locked.51f79a04.svg";